import { render, staticRenderFns } from "./TransactionInput.vue?vue&type=template&id=182d6a2e"
import script from "./TransactionInput.vue?vue&type=script&lang=js"
export * from "./TransactionInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports